import { useEffect, useState } from 'react';

// ✅ Importando imagem da pasta /assets/
import familia from '../../../assets/familia.png';

export default function AboutSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('sobre');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Conteúdo */}
          <div
            className={`transform transition-all duration-1000 ${
              isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'
            }`}
          >
            <h2
              className="text-4xl md:text-5xl font-bold text-gray-800 mb-6"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Mais de 60 Anos de Tradição e Inovação
            </h2>

            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                A <strong className="text-blue-600">Contabilidade Renzi Rossi</strong> é uma empresa familiar
                em sua terceira geração, combinando mais de 60 anos de experiência sólida com as mais
                modernas tecnologias do mercado contábil.
              </p>

              <p>
                Nossa missão é oferecer um <strong className="text-blue-600">atendimento de excelência</strong>,
                onde cada cliente recebe atenção personalizada e soluções sob medida para suas necessidades.
                Acreditamos que cada empresa tem seus sonhos e objetivos únicos.
              </p>

              <p>
                Somos especialistas em <strong className="text-blue-600">contabilidade 100% digital</strong> e
                <strong className="text-blue-600"> Imposto de Renda</strong>, oferecendo agilidade e precisão
                em todos os processos. Cuidamos tanto do seu Imposto de Renda Pessoa Física quanto Jurídica,
                garantindo máxima economia fiscal e cumprimento de todas as obrigações.
              </p>

              <p>
                Nosso compromisso é ser seu parceiro estratégico no crescimento sustentável do seu negócio,
                oferecendo transparência total, pontualidade rigorosa e resultados que fazem a diferença.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div
                  className="text-3xl font-bold text-blue-600 mb-2"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  60+
                </div>
                <p className="text-sm text-gray-600">Anos de Experiência</p>
              </div>
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div
                  className="text-3xl font-bold text-blue-600 mb-2"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  3ª
                </div>
                <p className="text-sm text-gray-600">Geração Familiar</p>
              </div>
            </div>
          </div>

          {/* Imagem */}
          <div
            className={`transform transition-all duration-1000 ${
              isVisible ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'
            }`}
          >
            <div className="relative">
              <img
                src={familia}
                alt="Tradição familiar em contabilidade - 60 anos de experiência"
                className="w-full h-90 sm:h-96 object-cover object-top rounded-xl shadow-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-xl"></div>

              {/* Badge de destaque */}
              <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg">
                <div className="flex items-center space-x-2">
                  <i className="ri-award-line text-blue-600"></i>
                  <span className="text-sm font-semibold text-gray-800">Tradição desde 1963</span>
                </div>
              </div>
            </div>

            {/* Cards de valores */}
            <div className="grid grid-cols-2 gap-4 mt-6">
              <div className="bg-white p-4 rounded-lg shadow-lg border-l-4 border-blue-600">
                <div className="flex items-center mb-2">
                  <i className="ri-heart-line text-blue-600 mr-2"></i>
                  <h4 className="font-semibold text-gray-800 text-sm">Humanização</h4>
                </div>
                <p className="text-xs text-gray-600">Atendimento próximo e personalizado</p>
              </div>

              <div className="bg-white p-4 rounded-lg shadow-lg border-l-4 border-blue-600">
                <div className="flex items-center mb-2">
                  <i className="ri-computer-line text-blue-600 mr-2"></i>
                  <h4 className="font-semibold text-gray-800 text-sm">Inovação</h4>
                </div>
                <p className="text-xs text-gray-600">Tecnologia de ponta e processos digitais</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
